export enum DIRECTIONS {
  UP = "up",
  DOWN = "down",
  NONE = "none",
}

export const NEAR_LINE_HEIGHT = 300;

export const DEFAULT_SCROLL_STATE = {
  position: 0,
  isNearTop: true, // around NEAR_LINE_HEIGHT from top
  isNearBottom: true, // around NEAR_LINE_HEIGHT from bottom
  direction: DIRECTIONS.NONE,
};
